export const NullTelemetry = (_) => { };
